import axios from "axios";
import GetCookieByName from "../../hooks/GetCookie";
// const config = require("../config/settings.json");

axios.defaults.baseURL = process.env.REACT_APP_API_URL;

function setToken(token) {
  axios.defaults.headers.common["x-auth-token"] = token;
}

try {
  const raw = GetCookieByName("auth");
  if (typeof raw === "string") {
    const parsed = JSON.parse(raw);
    if (parsed?.token) setToken(parsed.token);
  }
} catch {
  // cookie missing or not valid JSON — requests will auth via per-call headers
}

axios.interceptors.response.use(null, (error) => {
  return Promise.reject(error);
});


const http = {
  get: axios.get,
  post: axios.post,
  put: axios.put,
  patch: axios.patch,
  delete: axios.delete,
};

export default http;
